export default "__VITE_ASSET__BN7NgLRi__"